module.exports = __webpack_public_path__ + "img/mayor.04bafc78.jpg";